<template>
    <div>
        <h2>Activation</h2>
        <h4>Your instagram account service is activating. Please wait for a while. It takes about 10-30seconds.</h4>

        <div class="mt-5">
            <div v-if="activating" class="d-flex flex-column justify-content-center align-items-center">
                <strong>ACTIVATING...</strong>
                <md-progress-spinner
                    class="md-accent text-danger"
                    :md-diameter="70"
                    md-mode="indeterminate"
                ></md-progress-spinner>
            </div>
            <div v-else>
                <a-result title="Great, Your instagram account service is activated!">
                    <template #icon>
                        <a-icon type="check-circle" />
                    </template>
                    <template #extra></template>
                </a-result>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "Activation",
    data() {
        return {
            activating: true,
        };
    },
    props: {
        activated: {
            type: Function,
            default: () => {},
        },
    },
    computed: {
        ...mapState({
            initialized: (state) => state.instagram.info.initialized,
            status: (state) => state.instagram.info.status,
        }),
    },
    mounted() {
        if (this.initialized && this.status.created) {
            this.activating = false;
            this.activated();
        }
    },
    watch: {
        status(val) {
            if (val.created) {
                this.activating = false;
                this.activated();
            }
        },
    },
};
</script>

<style scoped></style>
